/**
 * Curated specialty adjacency — mirrors Backend SpecialtyRelationsCatalog (mobile).
 * Used for hospital shift posting suggestions without calling AI.
 */
export const SPECIALTY_RELATIONS: Record<string, string[]> = {
  "sp-1": ["sp-27", "sp-35", "sp-6"],
  "sp-2": ["sp-15", "sp-6", "sp-24", "sp-20"],
  "sp-3": ["sp-9", "sp-15", "sp-32", "sp-38"],
  "sp-4": ["sp-9", "sp-14", "sp-26"],
  "sp-5": ["sp-13", "sp-9"],
  "sp-6": ["sp-15", "sp-9", "sp-2", "sp-10", "sp-34"],
  "sp-7": ["sp-9", "sp-17", "sp-15"],
  "sp-8": ["sp-9", "sp-16", "sp-17"],
  "sp-9": ["sp-11", "sp-32", "sp-3", "sp-8", "sp-17", "sp-6", "sp-18"],
  "sp-10": ["sp-34", "sp-21", "sp-6", "sp-23", "sp-35"],
  "sp-11": ["sp-9", "sp-25", "sp-31", "sp-18"],
  "sp-12": ["sp-16", "sp-9", "sp-26"],
  "sp-13": ["sp-32", "sp-5", "sp-33"],
  "sp-14": ["sp-9", "sp-15", "sp-6", "sp-35"],
  "sp-15": ["sp-6", "sp-2", "sp-9", "sp-32", "sp-3"],
  "sp-16": ["sp-25", "sp-9", "sp-12", "sp-29"],
  "sp-17": ["sp-9", "sp-15", "sp-7"],
  "sp-18": ["sp-9", "sp-31", "sp-39"],
  "sp-19": ["sp-30", "sp-16"],
  "sp-20": ["sp-23", "sp-2", "sp-43"],
  "sp-21": ["sp-10", "sp-28", "sp-34"],
  "sp-22": ["sp-42"],
  "sp-23": ["sp-43", "sp-6", "sp-20", "sp-10"],
  "sp-24": ["sp-2", "sp-31", "sp-27"],
  "sp-25": ["sp-11", "sp-16", "sp-9"],
  "sp-26": ["sp-12", "sp-14"],
  "sp-27": ["sp-1", "sp-35", "sp-24"],
  "sp-28": ["sp-21", "sp-34", "sp-10"],
  "sp-29": ["sp-16", "sp-30"],
  "sp-30": ["sp-19", "sp-29"],
  "sp-31": ["sp-11", "sp-18", "sp-41", "sp-36"],
  "sp-32": ["sp-9", "sp-15", "sp-13"],
  "sp-33": ["sp-9", "sp-13"],
  "sp-34": ["sp-10", "sp-6", "sp-21"],
  "sp-35": ["sp-27", "sp-1", "sp-14"],
  "sp-36": ["sp-41", "sp-31", "sp-10"],
  "sp-37": ["sp-46", "sp-41", "sp-45", "sp-44", "sp-38"],
  "sp-38": ["sp-37", "sp-46", "sp-3", "sp-15"],
  // Addiction Medicine — psychiatry / general medicine crossover, not sexual health cluster
  "sp-39": ["sp-18", "sp-31", "sp-15", "sp-9"],
  "sp-40": ["sp-37", "sp-44", "sp-42"],
  "sp-41": ["sp-37", "sp-44", "sp-31", "sp-36"],
  "sp-42": ["sp-40", "sp-44", "sp-22"],
  "sp-43": ["sp-37", "sp-23", "sp-20"],
  "sp-44": ["sp-37", "sp-41", "sp-40", "sp-42"],
  "sp-45": ["sp-37", "sp-20", "sp-46"],
  "sp-46": ["sp-37", "sp-38", "sp-3"],
};

/** High-volume broad specialties — secondary suggestions when anchor is narrow. */
export const BROAD_SHIFT_SPECIALTY_IDS = [
  "sp-6",
  "sp-9",
  "sp-10",
  "sp-15",
  "sp-34",
];
